<template>
  <div class="logoimage">
    <div class="preview">
      <div class="image_wrapper">
        <img :src="file.src" />
      </div>
    </div>
    <div class="progress_info" v-if="file.progress<100">
      <div class="content">
        <div class="progress_overlay"></div>
        <div class="progress" style="height:12px">
          <div
            class="progress-bar bg-info"
            role="progressbar"
            :style="progressCompleted"
            :aria-valuenow="file.progress"
            aria-valuemin="0"
            aria-valuemax="100"
          >{{ file.progress }}%</div>
        </div>
      </div>
    </div>
    <div
      class="image-upload"
      v-bind:class="isDragover?'is-dragover':''"
      v-on:dragover="dragover"
      v-on:dragleave="dragleave"
    >
      <label style="cursor: pointer;" for="file_upload">
        <div class="h-100">
          <div class="dplay-tbl">
            <div class="dplay-tbl-cell">
              <i class="fas fa-camera"></i>
              <h6 class="mt-10 mb-70">
                <strong>Set new logo</strong>
              </h6>
            </div>
          </div>
        </div>

        <input
          data-required="image"
          type="file"
          id="file_upload"
          class="image-input"
          @change="doUpload"
          data-traget-resolution="image_resolution"
          value
          accept="image/*"
        />
      </label>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["options", "image"],
  data() {
    return {
      field: "logo",
      upload: null,
      isDragover: false
    };
  },
  computed: {
    file: {
      get() {
        return (
          this.upload || { src: this.image, completed: true, progress: 100 }
        );
      },
      set(newVal) {
        this.upload = newVal;
      }
    },
    progressCompleted() {
      return "width:" + this.file.progress + "%;";
    }
  },
  methods: {
    dragover() {
      this.isDragover = true;
    },
    dragleave() {
      this.isDragover = false;
    },
    reset() {
      this.upload = {};
      this.isDragover = false;
    },
    addImage(file) {
      this.file = file;
    },
    createImage(file, data) {
      //var image = new Image();
      var reader = new FileReader();

      reader.onload = e => {
        file.src = e.target.result;
      };
      reader.readAsDataURL(data);
    },
    doUpload(e) {
      var uploads = e.target.files || e.dataTransfer.files;
      if (!uploads.length) return;
      uploads.forEach((upload, idx) => {
        let file = {
          src: "",
          progress: 0,
          completed: false,
          xhr: axios.CancelToken.source()
        };
        this.createImage(file, upload);
        var formData = new FormData();
        this.$emit("uploadingEvent", file, formData);
        formData.append(this.field, upload);
        //console.log(file);
        axios
          .post(this.options.url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              ...this.options.headers
            },
            onUploadProgress: function(progressEvent) {
              var percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              file.progress = percentCompleted;
            },
            cancelToken: file.xhr.token
          })
          .then(res => {
            file.completed = true;
            this.$forceUpdate();
            this.$emit("completedEvent", file, res.data);
          })
          .catch(err => {
            console.log(err);
            this.$emit("errorEvent", file, err);
          });
        this.upload = file;
        this.isDragover = false;
      });
    },
    cancelUpload(file) {
      file.xhr.cancel();
      let idx = this.files.indexOf(file);
      this.files.splice(idx, 1);
    }
  }
};
</script>

<style scoped>
.logoimage {
  position: relative;
  width: 100%;
  padding-top: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: solid 1px #e5e5e5;
  box-sizing: content-box;
  border-radius: 50%;
}

.preview {
  position: absolute;
  width: 94%;
  height: 94%;
  top: 3%;
  bottom: 0;
  left: 3%;
  right: 0;
}

.image_wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
}

.image_wrapper img {
  flex: 1;
  max-height: 100%;
  height: auto;
  max-width: 200%;
  width: auto;
  align-self: center;
}

.image-upload {
  width: 100%;
  height: 100%;
  padding: 20px;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  color: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  opacity: 0;
  border-radius: 7px;
  transition: all 0.3s ease-in-out;
  border-radius: 50%;
}

.image-upload:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.5);
  color: #472f91;
  border: dashed 2px #967ad6;
}

.image-upload label {
  flex: 1;
}

.image-upload.is-dragover {
  background-color: rgba(255, 255, 255, 0.6);
  color: #111;
  border: 2px dashed #d7d7d7;
  opacity: 1;
}
.image-upload:hover i,
.image-upload.is-dragover i {
  color: #472f91;
}

.item-wrapper form img {
  margin-bottom: 20px;
  width: auto;
  height: auto;
  max-height: 400px;
  width: auto;
  border-radius: 5px;
  overflow: hidden;
}

.image-upload img {
  height: 100% !important;
  width: auto !important;
  border-radius: 0px;
  margin: 0 auto;
}

.image-upload i {
  font-size: 4em;
  color: #d7d7d7;
}

.image-upload input {
  cursor: pointer;
  opacity: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
}

.item-wrapper input {
  height: 100%;
  line-height: 43px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.progress_info {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.progress_info .content {
  position: relative;
  width: 100%;
  height: 100%;
}

.progress_info .progress_overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  opacity: 0.5;
  z-index: 5;
}

.progress_info .content .progress {
  position: absolute;
  top: 50%;
  left: 20px;
  right: 20px;
  z-index: 10;
}
</style>